export default "__VITE_ASSET__YDI4f9by__"